import Icon, { type AvailableIcons } from "~/components/ui/Icon";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import { useId } from "react";
import DialogJS from "~/components/ui/DialogJS";
import { type FnContext as FnContext } from "~/types/deco";
interface ItemModal {
    /**
     * @title Conteúdo do Modal
     * @format html
     */
    content: string;
}
/**
 * @titleBy icon
 */
interface Item {
    /**
     * @title Ícone
     */
    icon: AvailableIcons;
    /**
     * @title Título
     * @format html
     */
    label: string;
    modal: ItemModal;
}
interface DialogProps {
    buttonId: string;
    dialogId: string;
}
export interface Props {
    /**
     * @title Itens
     */
    items: Item[];
    layout: 'mobile' | 'desktop' | 'mixed';
    /**
     * @ignore
     */
    isMobile?: boolean;
}
export function loader(props: Props, _: Request, ctx: FnContext) {
    return {
        ...props,
        isMobile: ctx.device !== 'desktop',
    };
}
export default function Diferenciais({ layout, items, isMobile }: Props) {
    if (layout === 'mobile' && isMobile) {
        return (<div className='p-3 lg:hidden'>
                <ul className='grid max-w-3xl grid-cols-2 gap-2 mx-auto'>
                    {items.map(({ label, icon, modal }, index) => (<li id={`diferenciais-${index}-button-mobile`} className={index % 2 === 0 && index === items.length - 1
                    ? 'col-span-full'
                    : ''}>
                            <div className='flex items-center justify-center h-full gap-2 p-2 text-xs text-white text-center bg-black'>
                                <Icon id={icon as AvailableIcons} size={16} className='shrink-0'/>
                                <div dangerouslySetInnerHTML={{ __html: label }}/>
                            </div>
                            <dialog id={`diferenciais-${index}-modal-mobile`} className='modal'>
                                <div className='modal-box absolute top-[10%] rounded-none border-4 text-sm border-[#595955]'>
                                    <form method='dialog' className='absolute outline-none top-4 right-4 h-fit'>
                                        <button aria-label='Fechar'>
                                            <Icon id='XMark' size={18} strokeWidth={4}/>
                                        </button>
                                    </form>
                                    <div dangerouslySetInnerHTML={{ __html: modal.content }} className='[&_a]:bg-salmon [&_a]:text-white [&_a]:underline [&_a]:decoration-black'/>
                                </div>
                                <form method='dialog' className='modal-backdrop'>
                                    <button>Fechar</button>
                                </form>
                            </dialog>
                            <DialogJS buttonId={`diferenciais-${index}-button-mobile`} dialogId={`diferenciais-${index}-modal-mobile`}/>
                        </li>))}
                </ul>
            </div>);
    }
    const id = useId();
    if (layout === 'mixed') {
        return (<div className='relative text-xs h-[52px] min-[1025px]:bg-red-wine min-[1025px]:h-10'>
                <div id={id} className='absolute inset-0 z-0 grid items-center h-full grid-cols-1 grid-rows-1 mx-auto max-w-[1810px] gap-x-3'>
                    <Slider className='items-center h-full mx-3 carousel'>
                        {items.map(({ label, icon, modal }, index) => (<Slider.Item index={index} className='bg-black max-[480px]:!w-full max-[768px]:!w-1/2 max-[1024px]:!w-1/3 shrink-0 first:ml-0 last:mr-0 mx-[3px] px-3 min-[1025px]:bg-transparent min-[1025px]:mx-0' style={{
                    width: `${100 / items.length}%`,
                    minWidth: 'fit-content',
                }}>
                                <div id={`diferenciais-${index}-button-desktop`} className='py-2 text-white flex justify-center items-center gap-2 cursor-pointer'>
                                    <Icon id={icon as AvailableIcons} size={20} className='shrink-0'/>

                                    <div className='text-[10px] text-center font-light [&_strong]:text-[10px] [&_strong]:text-bege [&_strong]:font-black' dangerouslySetInnerHTML={{ __html: label }}/>
                                </div>

                                <dialog id={`diferenciais-${index}-modal-desktop`} className='modal'>
                                    <div className='modal-box absolute top-[10%] rounded-none border-4 text-sm border-[#595955]'>
                                        <form method='dialog' className='absolute outline-none top-4 right-4 h-fit'>
                                            <button aria-label='Fechar'>
                                                <Icon id='XMark' size={18} strokeWidth={4}/>
                                            </button>
                                        </form>
                                        <div dangerouslySetInnerHTML={{ __html: modal.content }} className='[&_a]:bg-salmon [&_a]:text-white [&_a]:underline [&_a]:decoration-black'/>
                                    </div>
                                    <form method='dialog' className='modal-backdrop'>
                                        <button>Fechar</button>
                                    </form>
                                </dialog>
                                <DialogJS buttonId={`diferenciais-${index}-button-desktop`} dialogId={`diferenciais-${index}-modal-desktop`}/>
                            </Slider.Item>))}
                    </Slider>
                    <Slider.PrevButton className='absolute flex items-center justify-center col-start-1 -translate-y-1/2 top-1/2 left-4 disabled:pointer-events-none disabled:opacity-0'>
                        <Icon className='text-salmon' size={20} id='FilledChevronLeft' strokeWidth={3}/>
                    </Slider.PrevButton>
                    <Slider.NextButton className='absolute flex items-center justify-center col-start-3 -translate-y-1/2 top-1/2 right-4 disabled:pointer-events-none disabled:opacity-0'>
                        <Icon className='text-salmon' size={20} id='FilledChevronRight' strokeWidth={3}/>
                    </Slider.NextButton>
                    <SliderJS rootId={id} infinite={isMobile}/>
                </div>
            </div>);
    }
    if (layout === 'desktop' && !isMobile) {
        return (<div className='relative hidden h-10 text-xs bg-red-wine lg:block'>
                <div id={id} className='absolute inset-0 z-0 grid items-center h-full grid-rows-1 mx-auto max-w-[1810px] grid-cols-[auto_1fr_auto] gap-x-3'>
                    <Slider className='items-center h-full col-start-2 row-start-1 carousel' style={{
                WebkitMask: 'linear-gradient(90deg, transparent, white 1%, white 99%, transparent)',
                mask: 'linear-gradient(90deg, transparent, white 1%, white 99%, transparent)',
            }}>
                        {items.map(({ label, icon, modal }, index) => (<Slider.Item index={index} 
            // Show X carousel items for each resolution
            // calc((100% / var(--columns)) - var(--gap) + 2px + ((var(--gap) + 2px) / var(--columns)));
            className='shrink-0 carousel-item justify-center lg:w-[calc(50%-14px+(14px/2))] min-[1110px]:w-[calc(33.333333%-14px+((14px)/3))] min-[1320px]:w-[calc(25%-14px+((14px)/4))] min-[1650px]:w-[calc(20%-14px+((14px)/5))]'>
                                <div id={`diferenciais-${index}-button-desktop`} className='py-2 text-white text-xs flex justify-center items-center gap-2 cursor-pointer'>
                                    <Icon id={icon as AvailableIcons} size={20} className='shrink-0'/>
                                    <div dangerouslySetInnerHTML={{ __html: label }} className='text-[10px] text-center font-light [&_strong]:text-[10px] [&_strong]:text-bege [&_strong]:font-black'/>
                                </div>
                                <dialog id={`diferenciais-${index}-modal-desktop`} className='modal'>
                                    <div className='modal-box absolute top-[10%] rounded-none border-4 text-sm border-[#595955]'>
                                        <form method='dialog' className='absolute outline-none top-4 right-4 h-fit'>
                                            <button aria-label='Fechar'>
                                                <Icon id='XMark' size={18} strokeWidth={4}/>
                                            </button>
                                        </form>
                                        <div dangerouslySetInnerHTML={{ __html: modal.content }} className='[&_a]:bg-salmon [&_a]:text-white [&_a]:underline [&_a]:decoration-black'/>
                                    </div>
                                    <form method='dialog' className='modal-backdrop'>
                                        <button>Fechar</button>
                                    </form>
                                </dialog>
                                <DialogJS buttonId={`diferenciais-${index}-button-desktop`} dialogId={`diferenciais-${index}-modal-desktop`}/>
                            </Slider.Item>))}
                    </Slider>
                    <Slider.PrevButton className='flex items-center justify-center col-start-1 disabled:pointer-events-none disabled:opacity-0'>
                        <Icon className='text-salmon' size={20} id='FilledChevronLeft' strokeWidth={3}/>
                    </Slider.PrevButton>
                    <Slider.NextButton className='flex items-center justify-center col-start-3 disabled:pointer-events-none disabled:opacity-0'>
                        <Icon className='text-salmon' size={20} id='FilledChevronRight' strokeWidth={3}/>
                    </Slider.NextButton>
                    <SliderJS rootId={id} infinite/>
                </div>
            </div>);
    }
    return <></>;
}
